import React from "react";
import { SimpleDropdown } from "../../../components/common/SimpleDropdown";

const gameStatusOptions = [
  { value: "upcoming", label: "Upcoming" },
  { value: "live", label: "Live" },
  { value: "completed", label: "Completed" },
  { value: "cancelled", label: "Cancelled" },
];

export const GamesTable = ({ games, loading, onDelete, onStatusChange, deleteLoading, statusUpdateLoading }) => {
  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: '2-digit' });
  };

  const getStatusBadgeColor = (status) => {
    switch (status) {
      case 'live':
        return 'bg-green-500/20 text-green-600 dark:text-green-400 border-green-500';
      case 'completed':
        return 'bg-jp-section text-jp-muted border-jp-line';
      case 'cancelled':
        return 'bg-red-500/20 text-red-600 dark:text-red-400 border-red-500';
      default: // upcoming
        return 'bg-sky-500/20 text-sky-600 dark:text-sky-400 border-sky-500';
    }
  };

  return (
    <div className="rounded-3xl bg-jp-card border border-jp-line overflow-hidden">
      <div className="overflow-x-auto">
        <table className="min-w-full text-[11px] border-collapse">
          <thead className="bg-jp-card text-jp-ink">
            <tr>
              <th className="px-4 py-2 text-center">DATE</th>
              <th className="px-4 py-2 text-center">TIME</th>
              <th className="px-4 py-2 text-center">HOME TEAM</th>
              <th className="px-4 py-2 text-center">AWAY TEAM</th>
              <th className="px-4 py-2 text-center">LOCATION</th>
              <th className="px-4 py-2 text-center">STATUS</th>
              <th className="px-4 py-2 text-center">STREAM</th>
              <th className="px-4 py-2 text-center">ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            {loading && games.length === 0 ? (
              <tr>
                <td colSpan={8} className="px-4 py-8 text-center text-jp-muted">
                  Loading games...
                </td>
              </tr>
            ) : games.length === 0 ? (
              <tr>
                <td colSpan={8} className="px-4 py-8 text-center text-jp-muted">
                  No games found
                </td>
              </tr>
            ) : (
              games.map((g) => (
                <tr
                  key={g._id}
                  className="border-t border-jp-line hover:bg-jp-section h-11"
                >
                  <td className="px-4 text-jp-ink align-middle text-center">
                    {formatDate(g.date)}
                  </td>
                  <td className="px-4 text-jp-ink align-middle text-center">{g.time}</td>
                  <td className="px-4 text-jp-ink align-middle text-center">
                    <div className="flex items-center justify-center gap-2">
                      {g.homeTeamId?.logo && (
                        <img src={g.homeTeamId.logo} alt="" className="w-5 h-5 object-contain" />
                      )}
                      <span>{g.homeTeamId?.name || (typeof g.homeTeamId === 'string' ? g.homeTeamId : '-')}</span>
                    </div>
                  </td>
                  <td className="px-4 text-jp-ink align-middle text-center">
                    <div className="flex items-center justify-center gap-2">
                      {g.awayTeamId?.logo && (
                        <img src={g.awayTeamId.logo} alt="" className="w-5 h-5 object-contain" />
                      )}
                      <span>{g.awayTeamId?.name || (typeof g.awayTeamId === 'string' ? g.awayTeamId : '-')}</span>
                    </div>
                  </td>
                  <td className="px-4 text-jp-ink align-middle text-center">
                    {g.location}
                  </td>
                  <td className="px-4 align-middle text-center">
                    <SimpleDropdown
                      value={g.status}
                      onChange={(val) => onStatusChange(g._id, val)}
                      options={gameStatusOptions}
                      variant="admin"
                      disabled={statusUpdateLoading[g._id]}
                      buttonClassName={`px-2 pr-7 py-1 rounded text-[10px] font-medium border ${getStatusBadgeColor(g.status)} bg-jp-card disabled:opacity-50 cursor-pointer flex items-center gap-1 whitespace-nowrap`}
                    />
                  </td>
                  <td className="px-4 align-middle text-center">
                    {g.streamLink ? (
                      <a
                        href={g.streamLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-sky-600 dark:text-sky-400 hover:underline"
                      >
                        Link
                      </a>
                    ) : (
                      <span className="text-jp-muted">-</span>
                    )}
                  </td>
                  <td className="px-4 align-middle text-center">
                    <button
                      onClick={() => onDelete(g._id)}
                      disabled={deleteLoading[g._id]}
                      className="text-red-600 dark:text-red-400 text-[11px] hover:text-red-300 disabled:opacity-50"
                    >
                      {deleteLoading[g._id] ? 'Deleting...' : 'Delete 🗑️'}
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
